"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTimer = exports.useTimer = exports.checkSession = exports.pathNameContains = void 0;
const React = __importStar(require("react"));
const useAuth0_1 = require("../hooks/useAuth0");
const utils_1 = require("../../utils/utils");
const react_router_dom_1 = require("react-router-dom");
exports.pathNameContains = (route) => {
    const routes = Array.isArray(route) ? route : [route];
    return routes.includes(document.location.pathname.toLowerCase());
};
exports.checkSession = (unprotectedRoutes) => {
    const session = {
        onDefaultRoute: false,
        authResult: null,
        iat: null,
        exp: null
    };
    if (exports.pathNameContains(unprotectedRoutes)) {
        session.onDefaultRoute = true;
    }
    const authResult = localStorage.getItem("authResult");
    if (authResult === null) {
        return session;
    }
    else {
        try {
            const parsedAuthResult = JSON.parse(authResult);
            session.authResult = parsedAuthResult;
            const accessTokenPayload = utils_1.decodeTokenPayload(parsedAuthResult.accessToken);
            session.iat = accessTokenPayload.iat;
            session.exp = accessTokenPayload.exp;
            return session;
        }
        catch (e) {
            delete session.authResult;
            delete session.iat;
            delete session.exp;
            return session;
        }
    }
};
exports.useTimer = (props) => {
    const { onDefaultRoute, exp, redirectToLogin } = props;
    const secToMs = 1000;
    React.useEffect(() => {
        if (!onDefaultRoute && exp !== null) {
            const msUntilExp = () => exp * secToMs - new Date().valueOf();
            const timer = setTimeout(() => redirectToLogin(), msUntilExp());
            return () => clearTimeout(timer);
        }
        return () => { };
    }, [exp, onDefaultRoute, redirectToLogin]);
    React.useEffect(() => {
        const handler = () => {
            if (!onDefaultRoute) {
                const lsAuthResult = localStorage.getItem("authResult");
                const lsCompId = localStorage.getItem("Company-Id") || "-1";
                const compId = parseInt(lsCompId);
                if (!lsAuthResult) {
                    redirectToLogin();
                }
                else if (compId === -1) {
                    document.location.replace("/SelectTenant");
                }
            }
        };
        const interval = setInterval(handler, 500);
        return () => clearInterval(interval);
    });
};
exports.SessionTimer = ({ callback, unprotectedRoutes }) => {
    const [session, setSession] = React.useState(exports.checkSession(unprotectedRoutes));
    const { logout } = useAuth0_1.useAuthContext();
    const location = react_router_dom_1.useLocation();
    const { pathname } = location;
    React.useEffect(() => {
        setSession(exports.checkSession(unprotectedRoutes));
    }, [pathname, unprotectedRoutes]);
    const redirectToLogin = function () {
        if (typeof callback === "function") {
            callback();
        }
        logout(`${document.location.origin}/Login`);
    };
    const { onDefaultRoute, authResult, iat, exp } = session;
    exports.useTimer({ onDefaultRoute, exp, redirectToLogin });
    if (!onDefaultRoute &&
        (authResult === null || iat === null || exp === null)) {
        redirectToLogin();
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=SessionTimer.js.map